module.exports = __webpack_public_path__ + "img/horizontal_7_6_0.057cfb0f.png";